import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'abs',
    standalone: false
})
export class AbsPipe implements PipeTransform {
    transform(value: number): number {
        return value == null ? null : Math.abs(value);
    }
}
